<template>
  <div class="BSCModal">
    <div
      class="BSCModal-background"
      :class="{ 'is-opaque': opaque }"
      @click="$emit('close')"
    />
    <transition name="BSCModal">
      <div class="BSCModal-content" :style="styleMain">
        <slot />
      </div>
    </transition>
  </div>
</template>

<script>
'use strict'

export default {
  name: 'BSCModal',
  props: {
    sizeW: {
      type: Number
    },
    sizeH: {
      type: Number
    },
    zIndex: {
      type: Number,
      default: 900
    },
    opaque: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      maxWidth: 'unset',
      maxHeight: 'unset'
    }
  },
  computed: {
    styleMain() {
      return {
        minWidth: `${this.sizeW}px`,
        minHeight: `${this.sizeH}px`,
        maxWidth: this.maxWidth,
        maxHeight: this.maxHeight,
        zIndex: this.zIndex
      }
    }
  },
  methods: {
    calcModalMaxSize() {
      this.maxWidth =
        this.sizeW >= window.innerWidth
          ? this.sizeW + 'px'
          : window.innerWidth * 0.8 + 'px'

      this.maxHeight =
        this.sizeH >= window.innerHeight
          ? this.sizeH + 'px'
          : window.innerHeight * 0.8 + 'px'
    }
  },
  mounted() {
    window.addEventListener('resize', this.calcModalMaxSize)
    this.calcModalMaxSize()
  },
  unmounted() {
    window.removeEventListener('resize', this.calcModalMaxSize)
  }
}
</script>
